import {
  Box,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDashboardStats } from "../hooks/useDashboardStats";
import { Alert, CircularProgress } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { useAppTranslation } from "../hooks/useAppTranslation";

interface DashboardTileProps {
  title: string;
  value: number;
  color: string;
  onClick: () => void;
}

function DashboardTile({
  title,
  value,
  color,
  onClick,
}: DashboardTileProps) {
  return (
    <Card
      onClick={onClick}
      sx={{
        cursor: "pointer",
        borderLeft: `6px solid ${color}`,
        transition: "0.2s",
        "&:hover": {
          boxShadow: 6,
        },
      }}
    >
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary">
          {title}
        </Typography>
        <Typography variant="h2" sx={{ mt: 1 }}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default function DashboardPage() {
    const { t } = useAppTranslation("common");

    const navigate = useNavigate();

    const { selectedCompany } = useAuth();
    const { data, loading, error } = useDashboardStats(selectedCompany);

    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return <Alert severity="error">{error}</Alert>;
    }

    if (!data) return null;


  return (
    <Box>
      <Typography variant="h3" fontWeight={500} gutterBottom mb={3}>
        {t("Panel główny")}
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: "repeat(3, 1fr)",
          },
          gap: 3,
        }}
      >
        <DashboardTile
          title={t("Nowe faktury")}
          value={data.pending}
          color="#ED6C02"
          onClick={() => navigate("/documents/pending")}
        />

        <DashboardTile
          title={t("Zaakceptowane")}
          value={data.approved}
          color="#2E7D32"
          onClick={() => navigate("/documents/approved")}
        />

        <DashboardTile
          title={t("Odrzucone")}
          value={data.rejected}
          color="#D32F2F"
          onClick={() => navigate("/documents/rejected")}
        />
      </Box>
    </Box>
  );
}
